// extracted by mini-css-extract-plugin
export default {"mediaButtonIcon":"VQ4Fpz","unmuted":"YSn2WN","muted":"FVrzSb","volumeBtn":"smzp2Q","volumeScale":"DQoHyZ","on":"tPlV3R","colorBlock":"ocKj5S","off":"J8UjUy","colorBlank":"mYXesB"};